
import { TEST_MENU_CONFIG } from './menuConfigs';
import LayoutBase from './LayoutBase';
import './layout.css';
import './layoutApp.css';

export const LayoutTest = () => (
  <LayoutBase 
    menuConfig={TEST_MENU_CONFIG} 
    navClass="niogems-layout-nav niogems-layout-nav-app"
  />
);

export default LayoutTest;